import React, { useEffect, useState } from "react";
import Dashboard from "../dashboard/Dashboard";
import "../../components/generalComponents.scss";
import style from "../../pages/reviews/review.module.scss";
import adminStyle from "./admin.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import showToast from "../../utils/show.toast";
import formatDate from "../../utils/date.formater";
import { Admin, listAdminByLevels } from "../../services/admin.service";
import Button from "../../components/buttons/Button";
import CreateAdminCard from "./component/create.modal";

interface IAdminList {
  isLoading: boolean;
  adminList: Admin[];
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function AdminListTablePage() {
  const query = useQuery();
  const level = query.get("level");
  const router = useNavigate();

  const [listAdmins, setAdminList] = useState<IAdminList>({
    isLoading: true,
    adminList: [],
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleModalOpen = () => setIsModalOpen(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setAdminList({ isLoading: true, adminList: [] });

        if (level === null || level === "") {
          showToast("Admin level is required", false);
          return;
        }

        const admins = await listAdminByLevels(level, 20);
        if (admins.status !== "success") {
          return showToast("Something wrong fetching admin datas!", false);
          setAdminList({ isLoading: false, adminList: [] });
        }

        // Set Admin List here
        setAdminList({ isLoading: false, adminList: admins.result.admins });
      } catch (error) {
        return showToast("Error fetching admin list", false);
      }
    };
    fetchData();
  }, [level]);

  return (
    <Dashboard pageTitle="Admin List">
      {/* Modal */}
      {isModalOpen && <CreateAdminCard setIsModalOpen={setIsModalOpen} />}
      <div className={style.languagePage}>
        <div className={style.counterCard}>
          <div className={style.titleTwrapper}>
            <FontAwesomeIcon
              onClick={() => router(-1)}
              icon={faArrowLeftLong}
              className={style.backIcon}
            />
            <h2>Admin User List</h2>
          </div>
        </div>

        <div className={style.pageTable}>
          {listAdmins.isLoading ? (
            <p
              className={style.textStyle}
              style={{ marginTop: "2px", marginBottom: "3px" }}
            >
              Loading admin list...
            </p>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginBottom: "1rem",
                }}
              >
                <button
                  className={adminStyle.createButton}
                  onClick={() => handleModalOpen()}
                >
                  Create Adminstrator
                </button>
              </div>
              <table>
                <>
                  <thead>
                    <tr>
                      <th>Firstname</th>
                      <th>Lastname</th>
                      <th>Email</th>
                    </tr>
                  </thead>
                  <tbody style={{ cursor: "pointer" }}>
                    {listAdmins.adminList.map((admin) => (
                      <tr
                        key={admin.id}
                        onClick={() =>
                          (window.location.href = `/admins/${admin.id}/details`)
                        }
                      >
                        <td>{admin.firstName}</td>
                        <td>{admin.lastName}</td>
                        <td>{admin.email}</td>
                      </tr>
                    ))}
                  </tbody>
                </>
              </table>
            </>
          )}
        </div>
      </div>
    </Dashboard>
  );
}
